import { createTheme } from "@material-ui/core/styles";
import red from "@material-ui/core/colors/red";

export const customTheme = createTheme({
  palette: {
    common: {
      black: "#000",
      white: "#fff",
    },
    type: "light",
    primary: {
      light: "#86caff",
      main: "#064be2",
      dark: "#0c40c1",
      contrastText: "#fff",
    },
    secondary: {
      light: "#ff4081",
      main: "#f50057",
      dark: "#d7004c",
      contrastText: "#fff",
    },
    error: {
      light: "#e57373",
      main: "#f44336",
      dark: "#d32f2f",
      contrastText: "#fff",
    },
    grey: {
      main: "#fafafa",
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#eeeeee",
      300: "#e0e0e0",
      400: "#bdbdbd",
      500: "#9e9e9e",
      600: "#757575",
      700: "#616161",
      800: "#424242",
      900: "#212121",
      A100: "#d5d5d5",
      A200: "#aaaaaa",
      A400: "#303030",
      A700: "#616161",
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
    text: {
      primary: "rgba(0, 0, 0, 0.87)",
      secondary: "rgba(0, 0, 0, 0.54)",
      disabled: "rgba(0, 0, 0, 0.38)",
      hint: "rgba(0, 0, 0, 0.38)",
      light: '#ffffff'
    },
    divider: "rgba(0, 0, 0, 0.12)",
    background: {
      paper: "#fff",
      default: "#fafafa",
    },
    action: {
      active: "rgba(0, 0, 0, 0.54)",
      hover: "rgba(0, 0, 0, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(0, 0, 0, 0.14)",
      disabled: "rgba(0, 0, 0, 0.26)",
      disabledBackground: "rgba(0, 0, 0, 0.12)",
    },
  },
  breakpoints: {
    keys: ["xs", "sm", "md", "lg", "xl"],
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  direction: "ltr",
  mixins: {
    toolbar: {
      minHeight: 56,
      "@media (min-width:0px) and (orientation: landscape)": {
        minHeight: 48,
      },
      "@media (min-width:600px)": {
        minHeight: 64,
      },
    },
  },
  typography: {
    fontFamily: '"Satoshi", "Helvetica", "Arial", sans-serif',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    display4: {
      fontSize: "7rem",
      fontWeight: 300,
      fontFamily: '"Satoshi", "Helvetica", "Arial", sans-serif',
      letterSpacing: "-.04em",
      lineHeight: "1.14286em",
      marginLeft: "-.04em",
      color: "rgba(0, 0, 0, 0.54)",
    },
    display3: {
      fontSize: "3.5rem",
      fontWeight: 400,
      fontFamily: '"Satoshi", "Helvetica", "Arial", sans-serif',
      letterSpacing: "-.02em",
      lineHeight: "1.30357em",
      marginLeft: "-.02em",
      color: "rgba(0, 0, 0, 0.54)",
    },
    display2: {
      fontSize: "2.8125rem",
      fontWeight: 400,
      fontFamily: '"Satoshi", "Helvetica", "Arial", sans-serif',
      lineHeight: "1.06667em",
      marginLeft: "-.02em",
      color: "rgba(0, 0, 0, 0.54)",
    },
    display1: {
      fontSize: "2.125rem",
      fontWeight: 400,
      fontFamily: '"Satoshi", "Helvetica", "Arial", sans-serif',
      lineHeight: "1.20588em",
      color: "rgba(0, 0, 0, 0.54)",
    },
    headline: {
      fontSize: "1.5rem",
      fontWeight: 400,
      fontFamily: '"Satoshi", "Helvetica", "Arial", sans-serif',
      lineHeight: "1.35417em",
      color: "rgba(0, 0, 0, 0.87)",
    },
    title: {
      fontSize: "1.3125rem",
      fontWeight: 500,
      fontFamily: '"Satoshi", "Helvetica", "Arial", sans-serif',
      lineHeight: "1.16667em",
      color: "rgba(0, 0, 0, 0.87)",
    },
    subheading: {
      fontSize: "1rem",
      fontWeight: 400,
      fontFamily: '"Satoshi", "Helvetica", "Arial", sans-serif',
      lineHeight: "1.5em",
      color: "rgba(0, 0, 0, 0.87)",
    },
    body2: {
      fontSize: "0.875rem",
      fontWeight: 500,
      fontFamily: '"Satoshi", "Helvetica", "Arial", sans-serif',
      lineHeight: "1.71429em",
      color: "rgba(0, 0, 0, 0.87)",
    },
    body1: {
      fontSize: "0.875rem",
      fontWeight: 400,
      fontFamily: '"Satoshi", "Helvetica", "Arial", sans-serif',
      lineHeight: "1.46429em",
      color: "rgba(0, 0, 0, 0.87)",
    },
    caption: {
      fontSize: "0.75rem",
      fontWeight: 400,
      fontFamily: '"Satoshi", "Helvetica", "Arial", sans-serif',
      lineHeight: "1.375em",
      color: "rgba(0, 0, 0, 0.54)",
    },
    button: {
      fontSize: "0.875rem",
      textTransform: "initial",
      fontWeight: 500,
      fontFamily: '"Satoshi", "Helvetica", "Arial", sans-serif',
      color: "rgba(0, 0, 0, 0.87)",
    },
  },
  overrides: {
    MuiMenuItem: {
      root: {
        fontFamily: '"Satoshi"',
      },
    },
    MUIDataTableToolbar: {
      actions: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
      },
      icon: {
        color: "#064be2",
        "& svg": {
          color: "white",
          width: "25px",
          cursor: "pointer",
          height: "25px",
          padding: "5px",
          boxShadow: "0 3px 9px 0 rgba(0,0,0,0.3)",
          borderRadius: "100%",
          backgroundColor: "#064be2",
        },
      },

      iconActive: {
        color: "#064be2",
        "& svg": {
          color: "white",
          width: "25px",
          cursor: "pointer",
          height: "25px",
          padding: "5px",
          boxShadow: "0 3px 9px 0 rgba(0,0,0,0.3)",
          borderRadius: "100%",
          backgroundColor: "#064be2",
        },
      },
    },
    MUIDataTableBody: {
      emptyTitle: {
        "@media (max-width: 425px)": {
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        },
        "@media (max-width: 959.95px)": {
          marginLeft: "-100px",
        },
      },
    },

    MUIDataTableBodyCell: {
      stackedCommon: {
        "@media (max-width:959.95px)": {
          fontSize: "13px !important",
          "&:nth-last-child(2)": { fontWeight: 700 },
          "&:last-child": { lineBreak: "anywhere" },
        },
      },
      responsiveStackedSmallParent: {
        "@media (max-width:425px)": {
          width: "93%",
        },
      },
    },
    MuiTable: {
      root: {
        "& caption": {
          fontFamily: '"Satoshi" !important',
        },
      },
    },
    MuiTab: {
      root: {
        minWidth: "20% !important",
      },
      wrapper: {
        textTransform: "initial !important",
      },
    },
    MuiTabs: {
      scroller: {
        overflowX: "auto !important",
      },
    },
    MuiBadge: {
      badge: {
        height: "30px!important",
        fontFamily: '"Satoshi" !important',
      },
      colorSecondary: {
        backgroundColor: red[500] + "!important",
      },
      anchorOriginTopLeftCircular: {
        top: "14%",
        left: "-21px",
        inlineSize: "max-content",
      },
    },
    MuiTableCell: {
      head: {
        color: "#121224",
        backgroundColor: "#f0f5f9 !important",
        fontSize: "15px !important",
        fontWeight: "bold",
        letterSpacing: "0.02em",
      },
      body: {
        color: "#121224",
        fontFamily: '"Satoshi" !important',
        fontSize: "13.5px !important",
        "&:last-child": {
          whiteSpace: "nowrap",
        },
      },

      root: {
        padding: "14px",
        fontFamily: '"Satoshi" !important',
      },
      paddingCheckbox: {
        "@media (max-width:959.95px)": {
          width: "10px",
        },
      },
    },
    MuiList: {
      padding: {
        paddingBottom: "0px !important",
      },
    },
    MuiListItem: {
      secondaryAction: {
        paddingRight: "45px !important",
      },
    },
    // MuiSelect: {
    //   select: {
    //     "&:focus": {
    //       backgroundColor: "none !important",
    //     },
    //   },
    // },

    MuiTableRow: {
      root: {
        "&:nth-of-type(odd)": {
          backgroundColor: "white",
        },
        "&:nth-of-type(even)": {
          backgroundColor: "#f0f5f9",
        },
      },
    },

    MuiIconButton: {
      root: {
        padding: "9px",
      },
    },

    MuiTypography: {
      body2: {
        fontSize: "0.875rem",
        fontWeight: 500,
        fontFamily: '"Satoshi", "Helvetica", "Arial", sans-serif',
        lineHeight: "1.71429em",
        color: "rgba(0, 0, 0, 0.87)",
      },
      body1: {
        fontSize: "0.875rem",
        fontWeight: 400,
        fontFamily: '"Satoshi", "Helvetica", "Arial", sans-serif',
        lineHeight: "1.46429em",
        color: "rgba(0, 0, 0, 0.87)",
      },
      caption: {
        fontSize: "0.75rem",
        fontWeight: 400,
        fontFamily: '"Satoshi", "Helvetica", "Arial", sans-serif',
        lineHeight: "1.375em",
        color: "rgba(0, 0, 0, 0.54)",
      },
      button: {
        fontSize: "0.875rem",
        textTransform: "uppercase",
        fontWeight: 500,
        fontFamily: '"Satoshi", "Helvetica", "Arial", sans-serif',
        color: "rgba(0, 0, 0, 0.87)",
      },
    },
    MuiPaper: {
      elevation4: {
        boxShadow: "none",
      },
    },

    MuiDialog: {
      paper: {
        margin: "15px !important",
        border: "1px solid #000 !important",
      },
    },

    MuiFab: {
      root: {
        "&:hover": {
          backgroundColor: "064be2 !important",
        },
      },
    },
    MuiButton: {
      root: {
        fontFamily: '"Satoshi !important"',
        fontSize: "14px",
        fontWeight: 500,
        boxShadow: "0 3px 9px 0 rgba(0,0,0,0.3) !important",
        "@media (max-width:959.95px)": { fontSize: "10px !important" },
        "& .Mui-disabled": {
          color: "rgba(0, 0, 0, 0.26) !important",
          backgroundColor: "rgba(0, 0, 0, 0.26) !important",
        },
      },
      label: {
        fontFamily: '"Satoshi" !important',
        fontSize: "14px",
        "@media (max-width:959.95px)": {
          fontSize: "10px !important",
        },
      },
      containedPrimary: {
        backgroundColor: "#064be2",
        textTransform: "initial !important",
        "&:active": {
          backgroundColor: "#0c40c1 !important",
          color: "#fff !important",
        },
        "&:hover": {
          backgroundColor: "#0c40c1 !important",
          color: "#fff !important",
        },
        "&:disabled": {
          backgroundColor: "#064be2c7 !important",
          color: "#fff !important",
        },
      },
      containedSizeSmall: {
        textTransform: "initial !important",
        padding: "4px 10px !important",
        fontWeight: "300 !important",
        height: "fit-content !important",
      },
      containedSecondary: {
        backgroundColor: red[500] + "!important",
        "&:active": {
          backgroundColor: red[600] + "!important",
          color: "#fff !important",
        },
        "&:hover": {
          backgroundColor: red[600] + "!important",
          color: "#fff !important",
        },
      },
    },
    MuiFormLabel: {
      root: {
        fontFamily: '"Satoshi" !important',
        fontSize: "20px",
        "@media (max-width:959.95px)": {
          fontSize: "15px !important",
        },
        color: "rgba(0, 0, 0, 0.87)",
      },
    },
    MuiCheckbox: {
      root: {
        color: "#bcbdbf",
      },
    },
    MuiFormControl: {
      root: {
        width: "100%",
      },
    },
    MuiTooltip: {
      tooltip: {
        fontFamily: '"Satoshi" !important',
      },
    },
    MuiInputBase: {
      root: {
        width: "100%",
      },
      input: {
        width: "100%",
        border: "none",
        fontSize: "13px",
        display: "block",
        padding: "10px 12px !important",

        borderRadius: "4px",
      },
    },

    MuiAutocomplete: {
      input: {
        width: "100% !important",
      },
    },

    MuiFilledInput: {
      root: {
        width: "100%",
        display: "block",
        padding: "0px 25px 0px 0px !important",
        position: "relative",
        fontSize: "13px",
        marginTop: "24px",

        backgroundColor: "white",
        "&:hover": {
          backgroundColor: "unset !important",
        },
        "&.Mui-focused": {
          backgroundColor: "unset !important",
        },
      },

      underline: {
        "&&&:before": {
          borderBottom: "none",
        },
        "&&:after": {
          borderBottom: "none",
        },
      },
      inputAdornedEnd: {
        border: "1px solid #ced4da",
      },
    },

    MuiOutlined: {
      MuiChip: {
        avatar: {
          margin: "0px",
        },
      },
    },

    MuiCardContent: {
      root: {
        "&:last-child": {
          paddingBottom: "10px !important",
        },
      },
    },
    MuiCardActions: {
      root: {
        marginBottom: "1px !important",
      },
    },

    MuiDrawer: {
      paperAnchorBottom: {
        width: "50%",
        left: "30%",
        bottom: "10%",
      },
      paper: {
        overflowY: "auto",
        overflowX: "hidden",
      },
    },

    // MuiChip: {
    //   avatar: {
    //     width: "50px !important",
    //     height: "50px !important",
    //     fontSize: "1.5rem !important",
    //     margin: "0px",
    //   },
    // },
    MuiInputLabel: {
      shrink: {
        width: "max-content",
      },
    },
  },
  MuiFormGroup: {
    row: {
      marginTop: "10px !important",
    },
  },
});
